import React from 'react';
import { useTreatmentContext } from '../../../../Services/TreatmentContext';
import Modal from '../../../../Components/Modal/Modal';
import NCZIPatient from '../NCZIPatient/NCZIPatient';
import PatientVerifyInformations from './PatientVerifyInformations';

interface Props {
	opened: boolean;
	patientId: string;
	onClose: (needReload: boolean) => void;
}

const PatientVerifyInformationsModal: React.FC<Props> = props => {
	const { opened, onClose, patientId } = props;
	const { isCase } = useTreatmentContext();

	return (
		<Modal
			opened={opened}
			onClose={() => onClose(false)}
			fullScreen={false}
			wrapChat={isCase}>
			<Modal.Header
				title={'patientTreatment.profile.verifyInformations.title'}
			/>
			<Modal.Content>
				<NCZIPatient>
					<PatientVerifyInformations onClose={() => onClose(true)} />
				</NCZIPatient>
			</Modal.Content>
		</Modal>
	);
};

export default PatientVerifyInformationsModal;
